module.exports = __webpack_public_path__ + "assets/img/page5-design-side-nav-expand-56125d96.png";